/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateVeetingMeetingRequestDto } from '../../models/create-veeting-meeting-request-dto';
import { VeetingMeetingDto } from '../../models/veeting-meeting-dto';

export interface CreateVeetingMeeting$Params {
  'X-API-Version'?: string;
      body: CreateVeetingMeetingRequestDto
}

export function createVeetingMeeting(http: HttpClient, rootUrl: string, params: CreateVeetingMeeting$Params, context?: HttpContext): Observable<StrictHttpResponse<VeetingMeetingDto>> {
  const rb = new RequestBuilder(rootUrl, createVeetingMeeting.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VeetingMeetingDto>;
    })
  );
}

createVeetingMeeting.PATH = '/api/veeting-meeting';
